import { LEPC_IDS } from "../../../constants";
import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "Richland County Form and Fees": {
    parameters: {
      linkUrls: ["https://www.notion.so/encamp/Richland-County-041520ca39d94b8ab9f6207c0b78ca98"],
      staffInputs: {
        fees: true,
        documentTypes: {
          submission: true,
          invoice: true,
        },
      },
      includeLepcs: [
        {
          id: LEPC_IDS.SC.RICHLAND_COUNTY,
          name: "Richland County",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "SC",
  },
};
